import React, { Component } from 'react';
import { getAppView, updateAppData } from '../Networking/APIClient';
import { downloadTranslations } from '../Networking/TranslationGetter';
import Login from '../Pages/Login';
import SignUp from '../Pages/SignUp';
import ForgotPassword from '../Pages/ForgotPassword';
import AccountOverview from '../Pages/AccountOverview';
import EditProfileContainer from '../Pages/EditProfileContainer';
import ChangePassword from '../Pages/ChangePassword';
import Subscription from '../Pages/Subscription';
import MainMenu from '../Components/MainMenu';
import LoadingPage from '../Components/LoadingPage';
import ChangeEmail from '../Pages/ChangeEmail';
import Receipts from '../Pages/Receipts';
import ChangeGatewayOwnership from '../Pages/ChangeGatewayOwnership';
import ChangeSubscription from '../Pages/ChangeSubscription';
import ReplaceGateway from '../Pages/ReplaceGateway';
import AssignGateway from '../Pages/AssignGateway';

let self;

class Main extends Component {
    constructor(props) {
        super(props);
        self = this;

        this.onCredentialsCorrect = this.onCredentialsCorrect.bind(this);
        this.updatePage = this.updatePage.bind(this);
        this.updateCustomerProperty = this.updateCustomerProperty.bind(this);
        this.logout = this.logout.bind(this);
        this.getTranslation = this.getTranslation.bind(this);

        this.updateAppData = this.updateAppData.bind(this);

        this.state = {
            language: null,
            credentials: {
                email: '',
                password: ''
            },

            data: null,
            translations: null,

            currentPage: 'login',

            loggedIn: false,
            limitedAccess: false,
            usingValueCode: false,
            automaticLogin: false,
            paymentStatus: null,
            customerIsRegistered: null,
            isLoading: null,
            menuIsClickable: true,
            hasMultipleGateways: false,
            shouldRenewSubscription: false,
            gatewayToBeReplaced: null,
            selectedSubscription: null,
            currentSubscriptionType: null,
        }
    }

    updateAppData() {
        const onAppDataUpdated = function onAppDataUpdated(data) {
            self.setState({
                data: data,
                customerIsRegistered: data.customer.customer_is_registered
            })
        };

        updateAppData(this.state.credentials, this.state.limitedAccess, onAppDataUpdated)
    }

    getTranslation(key) {
        if (this.state.translations != null) {
            const value = this.state.translations[key];
            if (value != null) {
                return value;
            } else {
                console.log("Translation for " + key + " not found.");
                return key;
            }
        } else {
            /*
             This will occur the first time the login page renders, as translations
             have not yet been downloaded. As soon as the translations are set,
             the page will re-render and update the fields.
            */
            return key;
        }
    }

    onCredentialsCorrect(accessType, myCredentials) {
        const onOk = function response(bpapi_result, accessType, hasMultipleGateways) {
            self.setState({
                credentials: myCredentials,
                data: bpapi_result,
                currentPage: 'account_overview',
                limitedAccess: accessType === 'LimitedAccessRegistrationIdUsed',
                customerIsRegistered: bpapi_result.customer.customer_is_registered,
                hasMultipleGateways: hasMultipleGateways
            });
        };

        const onError = function onError() {
            self.setLoading(false);
        };

        // Todo: clean. possibly remove this and use updateAppData instead.
        getAppView(myCredentials, accessType, onOk, onError);
    }

    updatePage(page) {
        console.log('Updating page to: ' + page)
        this.setState({
            currentPage: page
        })
    }

    updatePageWithProps = (page, props) => {
        console.log('Updating page to: ' + page);
        this.setState({
            ...props,
            currentPage: page
        });
    };

    updateCustomerProperty(propertyName, propertyValue) {
        /**
         * Example: Set state: data.customer.first_name = Richard
         * Two problems arrive here:
         * 1) React does not support nested updated. This means we have to use the ...spread operator
         * 2) We want to use the computed value of propertyName (e.g. first_name), but this is not straight
         *    forward when working with nested objects.
         * Solution:
         * https://stackoverflow.com/questions/34072009/update-nested-object-with-es6-computed-property-name
         */
        this.setState({
            ...this.state,
            data: {
                ...this.state.data,
                customer: {
                    ...this.state.data.customer,
                    [propertyName]: propertyValue
                }
            }
        });
    }

    logout() {
        console.log('Logging out');
        // By reloading the entire page, we clear all information, which clears any possible
        // query inputs if the user has logged in from the app.
        window.open(getDefaultUrl(), "_self")

        /*this.setState({
            initialValueCode: null,
            credentials: {
                email: '',
                password: ''
            },
            currentPage: 'login',
            data: null,
            loggedIn: false,
        })
        */
    }

    // It is important that credentials, value code flag and auto login flag are set
    // in componentWillMount. If it was set in componentDidMount, the Login content
    // would render before the state with the new values has actually been updated.
    componentWillMount() {
        if (this.props.paymentStatus != null) {
            this.setState({
                paymentStatus: this.props.paymentStatus
            });
        }

        // Added 16 Jan 2023 to attempt to send customer directly to payment upon being sent to SAM from Sikom Living with the property shouldRenewSubscription=true
        if (this.props.shouldRenewSubscription != null) {
            if (this.props.shouldRenewSubscription === 'true') {
                this.setState({
                    shouldRenewSubscription: true
                });
            }
        }

        if (this.props.hasMultipleGateways === 'true') {
            console.log("Customer has multiple gateways. No auto login.");
            this.setState({
                usingValueCode: false,
                automaticLogin: false,
                isLoading: false,
            });
        } else if (this.props.initialValueCode != null) {
            console.log("Initial value code received. Trying to auto login.");
            this.setState({
                credentials: {
                    email: this.props.initialValueCode,
                    password: 'NotASecret',
                },
                usingValueCode: true,
                automaticLogin: true,
                isLoading: true,
            });
        }



        // If no language is defined, we set Norwegian by default
        let inputLanguage = this.props.language;
        if (this.props.language == null) {
            inputLanguage = 'nb-NO';
        }
        //inputLanguage = navigator.language || navigator.userLanguage;
        this.setAndDownloadLanguage(inputLanguage);
    }


    setAndDownloadLanguage(inputLanguage) {
        let userLang;
        if (inputLanguage === null) {
            userLang = 'nb-NO';
        } else {
            userLang = inputLanguage;
        }

        console.log("Language: " + userLang);
        const onTranslationsDownloaded = function onTranslationsDownloaded(translations) {
            console.log("Translations downloaded. Setting translation data");
            self.setState({
                language: userLang,
                translations: translations
            });
        };

        const onError = function onError() {
            console.log("Translation download failed!");
        };

        downloadTranslations(userLang, onTranslationsDownloaded, onError);
    }

    setUsingValueCode(usingValueCode) {
        self.setState({
            usingValueCode: usingValueCode
        });
    }

    setLimitedAccess(limitedAccess) {
        self.setState({
            limitedAccess: limitedAccess
        });
    }

    setCredentials(credentials) {
        self.setState({
            credentials: credentials
        });
    }

    setPaymentStatus(status) {
        self.setState({
            paymentStatus: status
        });
    }

    setLoading(loading) {
        self.setState({
            isLoading: loading
        });
    }

    // Method for setting shouldRenewSubscription
    setShouldRenewSubscription(boolean) {
        self.setState({
            shouldRenewSubscription: boolean
        });
    }

    // Method for setting chosen gateway value code to be replaced
    setGatewayToBeReplaced(chosenGateway) {
        self.setState({
            gatewayToBeReplaced: chosenGateway
        });
    }

    setAutomaticLogin(automaticLogin) {
        self.setState({
            automaticLogin: automaticLogin
        });
    }

    setMenuIsClickable(isClickable) {
        self.setState({
            menuIsClickable: isClickable
        });
    }

    render() {
        let content;
        let mainContent;
        let loginContent;
        let loadingContent;
        switch (this.state.currentPage) {
            case 'login':
                loginContent = <Login
                    setLoading={this.setLoading}
                    setUsingValueCode={this.setUsingValueCode}
                    usingValueCode={this.state.usingValueCode}
                    automaticLogin={this.state.automaticLogin}
                    initialCredentials={this.state.credentials}
                    getTranslation={this.getTranslation}
                    updatePage={this.updatePage}
                    paymentStatus={this.state.paymentStatus}
                    setPaymentStatus={this.setPaymentStatus}
                    setAutomaticLogin={this.setAutomaticLogin}
                    onCredentialsCorrect={this.onCredentialsCorrect}
                    language={this.state.language}
                    setAndDownloadLanguage={this.setAndDownloadLanguage} />
                break;
            case 'sign_up_login':
                loginContent =
                    <SignUp
                        data={this.state.data}
                        setCredentials={this.setCredentials}
                        credentials={this.state.credentials}
                        usingValueCode={this.state.usingValueCode}
                        setUsingValueCode={this.setUsingValueCode}
                        setLimitedAccess={this.setLimitedAccess}
                        t={this.getTranslation}
                        updatePage={this.updatePage}
                        comingFromLogin={true} />
                break;
            case 'recovery':
                loginContent = <ForgotPassword
                    getTranslation={this.getTranslation}
                    updatePage={this.updatePage}
                    updateCustomerProperty={this.updateCustomerProperty}
                    credentials={this.state.credentials} />
                break;
            case 'account_overview':
                mainContent = <AccountOverview
                    updatePage={this.updatePage}
                    isLoading={this.state.isLoading}
                    customer={self.state.data.customer}
                    usingValueCode={this.state.usingValueCode}
                    setLoading={this.setLoading}
                    setPaymentStatus={this.setPaymentStatus}
                    updateAppData={this.updateAppData}
                    paymentStatus={this.state.paymentStatus}
                    automaticLogin={this.state.automaticLogin}
                    setAutomaticLogin={this.setAutomaticLogin}
                    language={this.state.language}
                    credentials={this.state.credentials}
                    t={this.getTranslation}
                    data={self.state.data}
                    hasMultipleGateways={this.state.hasMultipleGateways}
                    customerIsRegistered={this.state.customerIsRegistered}
                    setGatewayToBeReplaced={this.setGatewayToBeReplaced}
                    setShouldRenewSubscription={this.setShouldRenewSubscription}
                    shouldRenewSubscription={this.state.shouldRenewSubscription}
                    updatePageWithProps={this.updatePageWithProps}
                    logout={this.logout} />
                break;
            case 'edit_profile':
                mainContent = <EditProfileContainer
                    updateAppData={this.updateAppData}
                    usingValueCode={this.state.usingValueCode}
                    customer={this.state.data.customer}
                    t={this.getTranslation}
                    updatePage={this.updatePage}
                    credentials={this.state.credentials} />
                break;
            case 'change_password':
                mainContent = <ChangePassword
                    updatePage={this.updatePage}
                    data={this.state.data}
                    setUsingValueCode={this.setUsingValueCode}
                    setCredentials={this.setCredentials}
                    t={this.getTranslation}
                    credentials={this.state.credentials} />
                break;
            case 'change_email':
                mainContent = <ChangeEmail
                    updateAppData={this.updateAppData}
                    updatePage={this.updatePage}
                    data={this.state.data}
                    setCredentials={this.setCredentials}
                    t={this.getTranslation}
                    setUsingValueCode={this.setUsingValueCode}
                    usingValueCode={this.state.usingValueCode}
                    credentials={this.state.credentials} />
                break;
            case 'add_gateway':
                mainContent =
                    <AssignGateway
                        updateAppData={this.updateAppData}
                        updatePage={this.updatePage}
                        data={this.state.data}
                        setUsingValueCode={this.setUsingValueCode}
                        setCredentials={this.setCredentials}
                        t={this.getTranslation}
                        setLoading={this.setLoading}
                        logout={this.logout}
                        isLoading={this.state.isLoading}
                        hasMultipleGateways={this.state.hasMultipleGateways}
                        initialValueCode={this.props.initialValueCode}
                        credentials={this.state.credentials} />
                break;
            case 'change_gateway_ownership':
                mainContent = <ChangeGatewayOwnership
                    updateAppData={this.updateAppData}
                    updatePage={this.updatePage}
                    data={this.state.data}
                    setUsingValueCode={this.setUsingValueCode}
                    setCredentials={this.setCredentials}
                    t={this.getTranslation}
                    setLoading={this.setLoading}
                    logout={this.logout}
                    isLoading={this.state.isLoading}
                    hasMultipleGateways={this.state.hasMultipleGateways}
                    initialValueCode={this.props.initialValueCode}
                    credentials={this.state.credentials} />
                break;
            case 'change_subscription':
                mainContent = <ChangeSubscription
                    updateAppData={this.updateAppData}
                    updatePage={this.updatePage}
                    data={this.state.data}
                    t={this.getTranslation}
                    setLoading={this.setLoading}
                    logout={this.logout}
                    isLoading={this.state.isLoading}
                    credentials={this.state.credentials}
                    selectedSubscription={this.state.selectedSubscription}
                    currentSubscriptionType={this.state.currentSubscriptionType}
                />;
                break;
            case 'replace_gateway':
                mainContent = <ReplaceGateway
                    updateAppData={this.updateAppData}
                    updatePage={this.updatePage}
                    data={this.state.data}
                    setUsingValueCode={this.setUsingValueCode}
                    setCredentials={this.setCredentials}
                    t={this.getTranslation}
                    setLoading={this.setLoading}
                    logout={this.logout}
                    isLoading={this.state.isLoading}
                    hasMultipleGateways={this.state.hasMultipleGateways}
                    initialValueCode={this.props.initialValueCode}
                    gatewayToBeReplaced={this.state.gatewayToBeReplaced}
                    credentials={this.state.credentials} />
                break;
            case 'sign_up':
                mainContent =
                    <SignUp
                        setMenuIsClickable={this.setMenuIsClickable}
                        data={this.state.data}
                        setCredentials={this.setCredentials}
                        credentials={this.state.credentials}
                        usingValueCode={this.state.usingValueCode}
                        setUsingValueCode={this.setUsingValueCode}
                        setLimitedAccess={this.setLimitedAccess}
                        t={this.getTranslation}
                        updatePage={this.updatePage}
                        comingFromLogin={false}
                        updateAppData={this.updateAppData}
                        logout={this.logout} />
                break;
            case 'subscription':
                mainContent = <Subscription
                    updatePage={this.updatePage}
                    isLoading={this.state.isLoading}
                    usingValueCode={this.state.usingValueCode}
                    setLoading={this.setLoading}
                    updateAppData={this.updateAppData}
                    automaticLogin={this.state.automaticLogin}
                    setAutomaticLogin={this.setAutomaticLogin}
                    language={this.state.language}
                    credentials={this.state.credentials}
                    getTranslation={this.getTranslation}
                    data={self.state.data}
                    customerIsRegistered={this.state.customerIsRegistered}
                    updatePageWithProps={this.updatePageWithProps}
                    hasMultipleGateways={this.state.hasMultipleGateways} />
                break;
            case 'receipts':
                mainContent = <Receipts
                    credentials={this.state.credentials}
                    isLoading={this.state.isLoading}
                    setLoading={this.setLoading}
                    language={this.state.language}
                    getTranslation={this.getTranslation} />
                break;
            default:
                mainContent = (
                    <p>
                        This page is not yet created
                    </p>
                );
        }

        if (this.state.isLoading) {
            loadingContent = <LoadingPage />;
        }

        // The loading component was previously rendered here directly.
        // This caused the main menu to disappear when loading.
        // Doing it this way means the menu will always be visible.
        const mainContentIncludingLoading = (
            <div>
                {loadingContent}
                {mainContent}
            </div>
        )


        if (this.state.data != null) {
            content =
                <MainMenu
                    menuIsClickable={this.state.menuIsClickable}
                    automaticLogin={this.state.automaticLogin}
                    data={this.state.data}
                    customerIsRegistered={this.state.customerIsRegistered}
                    getTranslation={this.getTranslation}
                    content={mainContentIncludingLoading}
                    currentPage={this.state.currentPage}
                    updatePage={this.updatePage}
                    logout={this.logout} >
                </MainMenu>;
        } else {
            content = null
        }

        let mainClassName = getBackgroundColorClassName()

        return (
            <div className={mainClassName}>
                {loginContent}
                {content}
            </div>
        );
    }
}

function getBackgroundColorClassName() {
    let url = process.env.REACT_APP_API_URL

    // If the environment variable is not set at all, we default to the white background.
    if (!url) {
        return 'Main'
    }

    switch (url) {
        case 'https://api.connome.com/api/':
            return 'Main'
        case 'https://api-test.connome.com/api/':
            return 'test-Main'
        case 'https://api-test-01.connome.com/api/':
            return 'test-01-Main'
        case 'https://api-test-02.connome.com/api/':
            return 'test-02-Main'
        default:
            return 'test-custom-Main'
    }
}

function getDefaultUrl() {
    const url = window.location.href;
    return url.split("?")[0];
}

export default Main;




// WEBPACK FOOTER //
// ./src/Main/Main.js